// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1YYQn","header":"MergedInvoice_header__1sQD4"};